module.exports = __webpack_public_path__ + "img/sword-fire-04.0e22a93c.png";